import { render, staticRenderFns } from "./addRecoveredMaterial.vue?vue&type=template&id=58096188&scoped=true"
import script from "./addRecoveredMaterial.vue?vue&type=script&lang=js"
export * from "./addRecoveredMaterial.vue?vue&type=script&lang=js"
import style0 from "./addRecoveredMaterial.vue?vue&type=style&index=0&id=58096188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58096188",
  null
  
)

export default component.exports